import {
  AskInviteeIcon,
  BlockIcon,
  EditPencilIcon,
  LocationPinIcon,
  PhoneIcon,
  QuestionCircleIcon,
  TypeCursorIcon
} from '@calendly/ui/components/icons'
import PropTypes from 'prop-types'

import AskInviteIcon from 'images/icons/ask-invitee-location.svg'
import CustomLocationIcon from 'images/icons/custom-location.svg'
import InboundCallIcon from 'images/icons/inbound-call.svg'
import LocationMarkerIcon from 'images/icons/location-marker.svg'
import OutboundCallIcon from 'images/icons/outbound-call.svg'
import GoogleMeetLogo from 'images/logos/google-meet.svg'
import GotomeetingLogo from 'images/logos/gotomeeting.svg'
import MsTeamsLogo from 'images/logos/ms-teams.svg'
import WebexLogo from 'images/logos/webex.svg'
import ZoomLogo from 'images/logos/zoom.svg'

const ICONS_FOR_KIND = {
  physical: LocationPinIcon,
  outbound_call: PhoneIcon,
  inbound_call: PhoneIcon,
  zoom_conference: ZoomLogo,
  ask_invitee: AskInviteeIcon,
  no_location: BlockIcon,
  custom: TypeCursorIcon,
  google_conference: GoogleMeetLogo,
  webex_conference: WebexLogo,
  microsoft_teams_conference: MsTeamsLogo,
  gotomeeting_conference: GotomeetingLogo
}

const ICONS_FOR_ONE_OFF_KIND = {
  physical: LocationMarkerIcon,
  google_conference: GoogleMeetLogo,
  zoom_conference: ZoomLogo,
  microsoft_teams_conference: MsTeamsLogo,
  webex_conference: WebexLogo,
  gotomeeting_conference: GotomeetingLogo,
  custom: CustomLocationIcon,
  ask_invitee: AskInviteIcon,
  inbound_call: InboundCallIcon,
  outbound_call: OutboundCallIcon
}

const NEW_ET_EDITOR_ICONS = {
  ...ICONS_FOR_KIND,
  ask_invitee: QuestionCircleIcon,
  custom: EditPencilIcon,
}

const IconComponent = ({ Icon, ...props }) => (
  typeof Icon === 'string'
    ? <img src={Icon} alt="" {...props} />
    : <Icon {...props} />
)

export const LocationIcon = ({ kind, isOneOff = false, useNewIcons = false, ...props }) => {
  if (isOneOff) {
    return <IconComponent Icon={ICONS_FOR_ONE_OFF_KIND[kind]} {...props} />
  }

  if (useNewIcons) {
    return <IconComponent Icon={NEW_ET_EDITOR_ICONS[kind]} {...props} />
  }

  return <IconComponent Icon={ICONS_FOR_KIND[kind]} {...props} />
}


LocationIcon.propTypes = {
  kind: PropTypes.string.isRequired,
  isOneOff: PropTypes.bool,
  useNewIcons: PropTypes.bool,
  eventTypeKind: PropTypes.string
}
